// MK-1 — markup and the margin it yields, printed together wherever a markup
// percentage is shown. margin = markup / (100 + markup).
export const MARKUP_CATEGORIES = ['materials', 'labor', 'subcontract', 'equipment', 'other'];
export const CATEGORY_LABELS = { materials: 'Materials', labor: 'Labor', subcontract: 'Subcontract', equipment: 'Equipment', other: 'Other' };
export const marginOf = (markupPct) => {
  const m = Number(markupPct);
  if (!Number.isFinite(m) || m <= -100) return 0;
  return (m / (100 + m)) * 100;
};
const pct = (v) => {
  const n = Number(v) || 0;
  const r = Math.round(n * 10) / 10;
  return `${Number.isInteger(r) ? r : r.toFixed(1)}%`;
};
// "25% markup · 20% margin"
export const markupPair = (markupPct) => `${pct(markupPct)} markup · ${pct(marginOf(markupPct))} margin`;
// "25% / 20%" — the short form for a row chip
export const markupShort = (markupPct) => `${pct(markupPct)} / ${pct(marginOf(markupPct))}`;
// The firm's effective per-category rates: a null follows the construction markup.
export const effectiveCategoryDefaults = (settings) => {
  const base = Number(settings?.default_markup_percent) || 0;
  const raw = settings?.category_markup_defaults || {};
  const out = {};
  for (const k of MARKUP_CATEGORIES) out[k] = raw[k] == null || raw[k] === '' ? base : Number(raw[k]);
  return out;
};
